// AriaOne unified design tokens — single source of truth for JS-side colour/shadow
// constants. Mirrors the CSS variables declared on :root in index.css. Import these
// instead of re-declaring local palettes inside individual components.

export const INK = "#141412";
export const SUB = "#6C6C69";
export const FAINT = "#6E6E6B";
export const MUTE = "#9B9B97";

export const HAIR = "#E9E9EC";
export const SOFT = "#F1F1F4";
export const RAIL = "#FBFBFD";
export const GROUND = "#F9F9FB";
export const CHROME = "#FFFFFF";

export const INDIGO = "#5856D6";
export const INDIGO_TXT = "#4A4AC2";
export const AMBER = "#FF9500";
export const AMBER_TXT = "#9A5A00";
export const RED = "#FF3B30";
export const RED_TXT = "#C4302A";
export const GREEN = "#34C759";
export const GREEN_TXT = "#1F7A46";

export const SHADOW_FLOAT = "0 10px 28px rgba(20,20,18,.14)";
export const SHADOW_RAISED = "0 24px 64px rgba(20,20,18,.20)";
export const SHADOW_DRAWER = "-20px 0 56px rgba(20,20,18,.18)";
export const BACKDROP = "rgba(20,20,18,.32)";

const tokens = {
  INK, SUB, FAINT, MUTE,
  HAIR, SOFT, RAIL, GROUND, CHROME,
  INDIGO, INDIGO_TXT, AMBER, AMBER_TXT, RED, RED_TXT, GREEN, GREEN_TXT,
  SHADOW_FLOAT, SHADOW_RAISED, SHADOW_DRAWER, BACKDROP,
};
export default tokens;
